import Cookies from "js-cookie";
import { log } from "@lululemon/mwa-utils";
import { isUserLoggedIn } from "@lululemon/mwa-auth";

/**
 * Do we need to call the API to fetch analytics digitalData?
 * @return {boolean}
 */
const shouldFetchDigitalData = () => {
  let cartCount = 0;
  if (typeof Cookies.get("cartCount") !== "undefined") {
    cartCount = parseInt(Cookies.get("cartCount"), 10);
  }

  return isUserLoggedIn() || cartCount > 0;
};

/**
 * Make a timeout-aware API call to fetch analytics data.
 *
 * @param {Number} timeoutMs
 */
const fetchData = async (apiHost, timeoutMs) => {
  const timeout = new Promise((resolve, reject) => {
    setTimeout(() => reject(new Error("Timeout")), timeoutMs);
  });
  const response = fetch(
    `${apiHost}/gsr/common/dataLayerJson.jsp?pagetype=shopLanding`,
    {
      mode: "cors",
      credentials: "include",
      method: "GET",
    }
  );
  return Promise.race([timeout, response]).then((r) => r.text());
};

/**
 * Fetch analytics data and merge it with existing window.digitalData.
 *
 * @param {Number} timeoutMs
 * @return {Object|null}
 */
/* eslint-disable-next-line import/prefer-default-export */
export async function loadDigitalData(apiHost, timeoutMs = 10000) {
  try {
    if (!shouldFetchDigitalData()) {
      return null;
    }

    /**
     * Warning: hack
     *
     * The API returns a string containing an HTML script tag like this:
     *
     * <script type="text/JavaScript"> var digitalData = { page : { } }</script>
     *
     * We need to extract the digitalData variable in that string into an
     * actual JavaScript variable so that we can work with it.  The only way to do
     * this is with an eval-like execution.  This is typically not safe, but
     * because we contol the API endpoint and it uses HTTPS, it should be fine
     * in this case.  Ideally, this endpoint would he modified to return JSON
     * data instead of an HTML <script> tag.
     */
    const content = await fetchData(apiHost, timeoutMs);
    const regexMatches = content.match(
      /<script.*?>((?!<script.*?>|<\/script>)([\s\S])+)<\/script>/im
    );
    if (!regexMatches) throw new Error("Unknown format");
    let [, rawScript] = regexMatches;
    rawScript = `${rawScript};return digitalData;`;

    /* eslint-disable no-new-func */
    const digitalData = Function(`"use strict";${rawScript}`)();
    // rename page.pageInfo.region key to page.pageInfo.geoRegion
    if (
      digitalData.page &&
      digitalData.page.pageInfo &&
      digitalData.page.pageInfo.region
    ) {
      digitalData.page.pageInfo.geoRegion = digitalData.page.pageInfo.region;
      delete digitalData.page.pageInfo.region;
    }

    return digitalData;
  } catch (e) {
    log.warning("Error loading analytics data from data layer", {
      error: e.message,
    });
    return null;
  }
}
